<template>

    <v-page fixed>

        <v-page-header title="Settings" icon="fas fa-toolbox" />

        <div class="page-body-container">
            <v-page-body-sidebar>
                <router-link v-if="['owner', 'admin', 'manager'].includes(user.member.role.slug)" class="nav-link" :to="{ name: 'settings-api-keys' }" :class="{ active: $route.name === 'settings-api-keys' }">API Keys</router-link>
                <router-link v-if="['owner', 'admin', 'manager'].includes(user.member.role.slug)" class="nav-link" :to="{ name: 'settings-domain' }" :class="{ active: $route.name.startsWith('settings-domain') }">Sending Domain</router-link>
                <router-link class="nav-link" :to="{ name: 'settings-senders' }" :class="{ active: $route.name.startsWith('settings-senders') }">Senders</router-link>
                <router-link class="nav-link" :to="{ name: 'settings-unsub-groups' }" :class="{ active: $route.name.startsWith('settings-unsub-groups') }">Unsubscribe Groups</router-link>
                <router-link class="nav-link" :to="{ name: 'settings-blocks' }" :class="{ active: $route.name.startsWith('settings-blocks') }">Custom Blocks</router-link>
                <router-link class="nav-link" :to="{ name: 'settings-integrations' }" :class="{ active: $route.name.startsWith('settings-integrations') }">Integrations</router-link>
                <router-link class="nav-link" :to="{ name: 'settings-options' }" :class="{ active: $route.name === 'settings-options' }">Options</router-link>
                <router-link class="nav-link" :to="{ name: 'install' }" :class="{ active: $route.name === 'install' }">Installation</router-link>
            </v-page-body-sidebar>
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>

    </v-page>

</template>

<script>

export default {

    computed: {

        user() {
            return this.$store.getters.user;
        },

    }

}

</script>